import React, { useEffect } from 'react';
import { Modal, Box, Title, Group, Button, Paper, Text, Table, Space } from '@mantine/core';
import { baseUrl } from '../../../../Constants/constant';
import useFetch from '../../../../Customhooks/useFetch';
import classes from '../TableProductData.module.css'

const ViewProductRow = ({ isOpen, onClose, productId }: any) => {
  const token = localStorage.getItem("token");

  const { data: productData, error, fetchData: getProductData } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  });

  useEffect(() => {
    if (isOpen && productId) {
      getProductData(`${baseUrl}admin/products/${productId}`);
    }
  }, [isOpen, productId]);

  const rows = productData?.data?.rows[0]?.ProductComponents?.map((component: any, index: number) => (
    <Table.Tr key={component.id}>
      <Table.Td>{index + 1}</Table.Td>
      <Table.Td>{component?.Vertical?.vertical_name}</Table.Td>
      <Table.Td>{component?.Category?.category_name}</Table.Td>
      <Table.Td>{component?.RawMaterial?.material_name}</Table.Td>
      <Table.Td>{component?.RawMaterialSubType?.sub_name}</Table.Td>
      <Table.Td>{component?.water_consumtion} (liter)</Table.Td>
      <Table.Td>{component?.RawMaterialSubType?.co2_embodiment} /g</Table.Td>
      <Table.Td>{component?.weight || 'N/A'}</Table.Td>
      <Table.Td>{component?.percentage || 'N/A'}</Table.Td>
      <Table.Td>{component?.gsm_size || 'N/A'}</Table.Td>
      <Table.Td>{component?.sheet_size_height || 'N/A'}</Table.Td>
      <Table.Td>{component?.sheet_size_width || 'N/A'}</Table.Td>
      <Table.Td>{component?.no_of_product || 'N/A'}</Table.Td>
      {/* <Table.Td>{component?.no_of_layer || 'N/A'}</Table.Td>
      <Table.Td>{component?.glue_type_co2 || 'N/A'}</Table.Td>
      <Table.Td>{component?.coverage || 'N/A'}</Table.Td>
      <Table.Td>{component?.ink_type_co2 || 'N/A'}</Table.Td> */}
    </Table.Tr>
  ));

  return (
    <Modal opened={isOpen} onClose={onClose} size="100%" centered withCloseButton={false}>
      <Box className="flex">
        <Title order={4}>{productData?.data?.rows[0]?.name}</Title>
      </Box>
      <Paper shadow="xs" className="p-4 rounded-lg">
        {/* Add your product details here */}
        {productData?.data?.rows[0]?.product_description && (
          <Text className="mt-4">
            {productData?.data?.rows[0]?.product_description}
          </Text>
        )}

        <Box className="mt-4">
          <Space h={'lg'} />
          {/* <Title order={5}>Component</Title> */}
          <Table striped className={classes.customtable}>
            <Table.Thead>
              <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                <Table.Th>S No.</Table.Th>
                <Table.Th>Vertical Name</Table.Th>
                <Table.Th>Category Description</Table.Th>
                <Table.Th>RawMaterial</Table.Th>
                <Table.Th>Sub RawMaterial</Table.Th>
                <Table.Th>Water Consumption (liters)</Table.Th>
                <Table.Th>CO2 Embodiment (g)</Table.Th>
                <Table.Th>Weight (g)</Table.Th>
                <Table.Th>Percentage(%)</Table.Th>
                <Table.Th>GSM Size</Table.Th>
                <Table.Th>Sheet Size Height</Table.Th>
                <Table.Th>Sheet Size Width</Table.Th>
                <Table.Th>No. of Product</Table.Th>
                {/* <Table.Th>No. of Layers</Table.Th>
                <Table.Th>Glue Type CO₂/cm</Table.Th>
                <Table.Th>Coverage</Table.Th>
                <Table.Th>Ink Type CO₂/cm</Table.Th> */}
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows}
            </Table.Tbody>
          </Table>
          <Space h={'lg'} />
        </Box>
      </Paper>
      <Group className="mt-4 justify-center">
        <Space h={'lg'} />
        <Button variant="filled" color="#404040" className="w-32 rounded-lg" onClick={onClose}>
          OK
        </Button>
      </Group>
    </Modal>
  );
};

export default ViewProductRow;